// extracted by mini-css-extract-plugin
export default {"Button":"styles_Button__8NSdP","Disabled":"styles_Disabled__qdwJM"};